import React from 'react';
import { NavLink, useLocation } from 'react-router-dom';

import logo from '../../assets/logo.webp';

export const Navbar = (props) => {
  const location = useLocation()

  return(
    <nav className={`navbar navbar-expand-lg justify-content-between px-2 px-md-5 py-3 position-fixed fixed-top ${location.pathname !== '/waitlist' && location.pathname !== '/participate-in-online-fitness-challenges' && 'bg-white'}`}>
      <div>
        <img className="img-logo" src={logo} alt="Tigbar Logo" />
      </div>
      {location.pathname !== '/waitlist' && location.pathname !== '/participate-in-online-fitness-challenges' ?
      <>
      <div>
        <div className="collapse navbar-collapse bg-white" id="navbarSupportedContent">
          <div className="navbar-nav">
            <NavLink to="/" end className="nav-item nav-link text-dark px-md-4">
              Home
            </NavLink>
            <NavLink to="/features" end className="nav-item nav-link text-dark px-md-4">
              Features
            </NavLink>
            <NavLink to="/faqs" end className="nav-item nav-link text-dark px-md-4">
              FAQs
            </NavLink>
            <a href="mailto:company@tigbar.com" className="nav-item nav-link text-dark px-md-4">
              Investments
            </a>
          </div>
        </div>
      </div>
      <div>
      <a href="https://www.producthunt.com/posts/tigbar?utm_source=badge-featured&utm_medium=badge&utm_souce=badge-tigbar" target="_blank" rel="noreferrer">
        <img src="https://api.producthunt.com/widgets/embed-image/v1/featured.svg?post_id=435799&theme=light" alt="Tigbar - Let&#0039;s&#0032;do&#0032;a&#0032;fun&#0032;challenge&#0032;with&#0032;friends | Product Hunt" style={{width: 250, height: 54}} width="250" height="54" />
      </a>
        <button
          className="navbar-toggler"
          type="button"
          data-toggle="collapse"
          data-target="#navbarSupportedContent"
          aria-controls="navbarSupportedContent"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon">
            <i className="fas fa-bars"></i>
          </span>
        </button>
        <a
          type="button"
          className="btn btn-primary"
          href="https://play.google.com/store/apps/details?id=com.tigbar"
          target="blank"
          rel="noreferrer"
        >
          Download App
        </a>
      </div>
      </>
      :
      <a
          className="btn btn-primary"
          href="#waitlist-div"
        >
          Join Waitlist
      </a>
    }
    </nav>
)
}
